import $ from "../../src/jquery/jquery.min";
import { servicios } from "../properties";
const datosFiscalesServiceDomain = servicios.facturas.descargaFactura.replace("/descarga","");
const services={
  getRegimenes : "/getRegimenes",
  readPDF : "/datosFiscales",
  updateDatosFiscales:"/updateDatosFiscales",
  eliminaDatosFiscales : "/eliminaDatosFiscales",
  getDatosRegimenFiscal : "/getDatosRegimenFiscal",
  validaRfc: "/validarRfc?"
}
const contentJson = "application/json";

export const ajax = (parametros) => {
  const { type = "GET", ...config } = parametros;
  const promesa = new Promise((resolve, reject) => {
    $.ajax({
      ...config,
      type,
      success: (res) => {
        const resParse = ifObject(res);
        resolve(resParse);
      },
      error: (err) => {
        reject(err);
      },
    });
  });

  return promesa;
};

export const getRegimenes = (cveCliente, tid) =>{
  const promesa = new Promise((resolve, reject) => {
      $.ajax({
        url: datosFiscalesServiceDomain+services.getRegimenes,
        method: "GET",
        timeout: 0,
        headers: {
          "Content-Type": contentJson,
          "Authorization": tid,
        },
        data: JSON.stringify({"cveCliente":cveCliente}),
        success: (res) => {
          resolve(res);
        },
        error: (err) => {
          reject(err);
        },
      })
    });
    
  return promesa;
}

export const saveDatosFiscales = (cveCliente, file, tid) =>{
  var form = new FormData();
  form.append("file", file);
  form.append("cveCliente", cveCliente);
  const promesa = new Promise((resolve, reject) => {
      $.ajax({
        url: datosFiscalesServiceDomain+services.readPDF,
        method: "POST",
        timeout: 0,
        contentType: false,
        processData: false,
        cache: false,
        headers: {
          "mimeType": "multipart/form-data",
          "Authorization":tid,
        },
        data: form,
        success: (res) => {
          resolve(res);
        },
        error: (err) => {
          reject(err);
        },
      })
    });

  return promesa;
}

export const eliminaDatosFiscales = (cveCliente, fileId, tid) =>{
  const promesa = new Promise((resolve, reject) => {
      $.ajax({
        url: datosFiscalesServiceDomain+services.eliminaDatosFiscales,
        method: "POST",
        timeout: 0,
        headers: {
          "Content-Type": contentJson,
          "Authorization": tid,
        },
        data: JSON.stringify({"cveCliente":cveCliente}),
        success: (res) => {
          resolve(res);
        },
        error: (err) => {
          reject(err);
        },
      })
    });
    
  return promesa;
}

export const getDatosRegimenFiscal = (cveCliente,tid) =>{
  const promesa = new Promise((resolve, reject) => {
      $.ajax({
        url: datosFiscalesServiceDomain+services.getDatosRegimenFiscal,
        method: "POST",
        timeout: 0,
        headers: {
          "Content-Type": contentJson,
          "Authorization": tid,
        },
        data: JSON.stringify({"cveCliente":cveCliente}),
        success: (res, textStatus, xhr) => {
          let response = {status: xhr.status};
          if(res){
            response = res;
            response.status =xhr.status;
          }
          console.log(response);
          resolve(response);
        },
        error: (err) => {
          reject(err);
        },
      })
    });
  return promesa;
}

export const updateDatosFiscales = (cveCliente, datosF,tid) =>{
  const promesa = new Promise((resolve, reject) => {
      $.ajax({
        url: datosFiscalesServiceDomain+services.updateDatosFiscales,
        method: "POST",
        timeout: 0,
        headers: {
          "Content-Type": contentJson,
          "Authorization": tid,
        },
        data: JSON.stringify({"cveCliente":cveCliente, "data":datosF}),
        success: (res) => {
          
          resolve(res);
        },
        error: (err) => {
          reject(err);
        },
      })
    });
  return promesa;
}

export const validaRfc = (uid, rfc, tid) =>{
  const promesa = new Promise((resolve, reject) => {
      $.ajax({
        url: datosFiscalesServiceDomain+services.validaRfc+"cliente="+uid+"&rfc="+rfc,
        method: "GET",
        timeout: 0,
        headers: {
          "Content-Type": contentJson,
          "Authorization": tid
        },
        success: (res) => {
          resolve(res);
        },
        error: (err) => {
          reject(err);
        },
      })
    });
  return promesa;
}



// WEBPACK FOOTER //
// ./src/miPerfil/datosfiscales.act.js